/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
/* eslint-disable */
window.PXUTheme.jsHeader = {
  init: function ($section) {
    const isSearchOpen = $('[data-search-type="overlay"]').hasClass('is-opened');
    // Add settings from schema to current object
    window.PXUTheme.jsHeader = $.extend(this, window.PXUTheme.getSectionData($section));

    let $stickyMenu = $('#shopify-section-sections--15155717898325__header');
    
    // Selectors
    this.$el = $('#header')
    this.$menuToggle = this.$el.find('.header__menu-toggle');
    let announcementHeight = $('.announcement-sticky-wrapper').height();

    // Overlaid header
    if (this.enable_overlay === true && isScreenSizeLarge()) {
      this.updateOverlayStyle(this.sectionUnderlayIsImage());
    }

    // Sticky header
    if (this.enable_sticky === true && isScreenSizeLarge()) {
      ///console.log("OH< ELLO THERE!")
      $stickyMenu.addClass('has-sticky');
     
      /*this.enableSticky(announcementHeight);

      $(window).on('resize', () => {
        this.enableSticky(announcementHeight);
      });*/
    }
    // mobile menu clicker events
    $('body').on('click', '[data-show-mobile-menu="false"]', function (e) {
      //console.log('ello there');
      //e.preventDefault();
      window.PXUTheme.mobileMenu.open();
    });
    $('body').on('click', '[data-show-mobile-menu="true"]', function (e) {
      //console.log('true dat');
      //e.preventDefault();
      window.PXUTheme.mobileMenu.close();
    });

    if (this.header_layout == 'centered' || this.header_layout == 'search_focus') {
      this.$menuToggle.on('click', () => {
        this.showStickyMenu();
      })
    } else if (this.header_layout == 'vertical') {
      $section.find('.header-sticky-wrapper').stick_in_parent();
      this.addOffScreenDropdownCheck();
    }

    if ($('.mega-menu').length > 0) {
      window.PXUTheme.jsMegaMenu.init($section);
    }

    if(!isScreenSizeLarge()) {
      this.unload();
      window.PXUTheme.mobileMenu.init();
    }

    $('.search-overlay__close').on('touchstart click', function(){
      window.PXUTheme.jsHeader.hideSearch();
    });

    $(document).on('click', '[data-ajax-cart-trigger]', function (e) {
      //console.log("testing")
      /*e.preventDefault();*/
      window.PXUTheme.jsHeader.showDrawer();

      return false;
    });


    $(document).on(' click', '[data-show-search-trigger]', function(e){
      //e.preventDefault();
      const $this = $(this);
      const isActive = $this.hasClass('is-active');
      
      if(!isActive){
        window.PXUTheme.jsHeader.showSearch();
      } else {
        window.PXUTheme.jsHeader.hideSearch();
      }
    });

    $(document).on(' click', '[data-show-mobile-search-trigger]', function(e){
      //e.preventDefault();
      // console.log("Clicking it"); 
      const $this = $(this);
      const isActive = $this.hasClass('is-active');
      
     const searchInput = document.querySelector('#q.snize-input-style[type="text"]');
      if (searchInput) {
          // Trigger multiple events that might be bound to the input
          //debugger;
          const events = ['focus', 'click', 'mousedown', 'touchstart'];
          
          events.forEach(eventType => {
              const event = new Event(eventType, { bubbles: true });
              searchInput.dispatchEvent(event);
          });
      }
    });

    if (isScreenSizeLarge() || !/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
      $('.dropdown-click--true .header__link:not(.primary-brand, .primary-logo)').on('touchstart click', function(e) { 
        var $this = $(this);
        window.PXUTheme.jsHeader.toggleMenuClick(e, $this);
      });
    }

    if (this.dropdown_click === false) {
      $('.navbar-item').on('mouseleave', function(){
        console.log("mouseleave event triggered");
        window.PXUTheme.jsHeader.collapseSubmenu($(this));
      });
    }

    $(document).on('keydown', '[data-show-search-trigger]', function(e) {
      console.log("keydown event triggered on search trigger");
      if (e.which === 13) {
        e.preventDefault(); 
        window.PXUTheme.jsHeader.showSearch();
      }
    });
    /*
    if (window.PXUTheme.theme_settings.search_layout == 'overlay') {
      console.log('Search layout:', window.PXUTheme.theme_settings.search_layout);
      document.body.addEventListener('click', e => {
        if (e.target === document.querySelector('[data-show-search-trigger]')) {
          console.log('ello there!');
          window.PXUTheme.jsHeader.hideSearch();
        }
      });
    }*/
  },
  /*toggleMenuClick: function(e, $this) {
    console.log("Toggle menu click");
    var $parentWrap = $this.parents('.has-dropdown, .has-mega-menu');
    //console.log("toggle menu click")
    if (!$parentWrap.hasClass('is-opened') && $parentWrap.length > 0) {
      // Prevent link on first click
      e.preventDefault();

      // Close all dropdowns & mega menu
      $('.has-dropdown, .has-mega-menu').removeClass('is-opened');
      $('.mega-menu__section').removeClass('is-active');

      // Open selected dropdown/mega menu
      $parentWrap.addClass('is-opened');
      $parentWrap.data('clicked', 'true');
    } else {

      // Close all dropdowns & mega menu
      $('.has-dropdown, .has-mega-menu').removeClass('is-opened');
      $('.mega-menu__section').removeClass('is-active');
    }

    /* Close dropdown if click anywhere outside dropdown menu
    $(window).on('click', function(e) {
      if ($(e.target).closest('.header__link, .navbar-dropdown').length === 0) {
        console.log("clicked outside");
        $('.has-dropdown, .has-mega-menu').removeClass('is-opened');
        $('.mega-menu__section').removeClass('is-active');
        window.PXUTheme.jsHeader.collapseSubmenu($('.navbar-item'));
      }
    });
  },*/
  collapseSubmenu: function(el) {
    console.log("collapse submenu");
    $(el).find('.has-submenu input').prop("checked", false);
  },
  showStickyMenu: function() {
    this.$menuToggle.toggleClass('is-active');
    this.$el.find('.sticky-menu-wrapper').toggleClass('is-visible');
  },
  hideStickyMenu: function() {
    this.$menuToggle.removeClass('is-active');
    this.$el.find('.sticky-menu-wrapper').removeClass('is-visible');
  },
  disableSticky: function() {
    let $stickyEl = $('#header');

    $stickyEl.unstick();
    $stickyEl.removeClass('sticky--enabled');

    setTimeout(function(){
      $stickyEl.css('height', 'auto');
    }, 250)
  },
  enableSticky: function(offset) {
    let $stickyEl = this.$el;
    //console.log("sticky--enabled header");
    $stickyEl.addClass('sticky--enabled');

    $stickyEl.sticky({
      wrapperClassName: 'header-sticky-wrapper is-desktop-only',
      zIndex: 70,
      topSpacing: offset || 0
    })
    .on('sticky-start', () => {
      let headerHeight;
      let announcementHeight;

      // Hide the mini cart for centered header layout
      if(window.PXUTheme.theme_settings.header_layout == 'centered') {
        $('.top-bar [data-ajax-cart-trigger] [data-ajax-cart-mini_cart]').css('display', 'none');
      }

      // Get header height is sticky enabled
      if(window.PXUTheme.jsHeader.enable_sticky == true && window.PXUTheme.theme_settings.header_layout != 'vertical') {
        headerHeight = window.PXUTheme.jsHeader.getHeaderHeight();
      }

      // Get announcement height is sticky enabled
      if(typeof window.PXUTheme.jsAnnouncementBar !== 'undefined' && window.PXUTheme.jsAnnouncementBar.enable_sticky == true && window.PXUTheme.theme_settings.header_layout != 'vertical') {
        announcementHeight = window.PXUTheme.jsAnnouncementBar.getAnnouncementHeight();
      } else {
        announcementHeight = 0;
      }

      let totalHeight = headerHeight + announcementHeight;
      $stickyEl.parent().parent().find('.search-overlay').addClass('sticky-search').css('top', totalHeight + 'px');

      if (this.enable_overlay === true && this.sectionUnderlayIsImage() === true)  {

        $stickyEl.parent().addClass('has-overlaid-header');
        this.disableOverlayStyle();

      } else if (this.enable_overlay === true) {

        this.disableOverlayStyle();

      }
    })
    .on('sticky-end', () => {
      $stickyEl.parent().parent().find('.search-overlay').removeClass('sticky-search').css('top', '100%');

      // Safety timeout for logo width transition which can throw calculated height off
      setTimeout(() => {
        $stickyEl.sticky('update');
      }, 250);

      // Un-hide the mini cart when scrolled back to the top
      if(window.PXUTheme.theme_settings.header_layout == 'centered') {
        $('.top-bar [data-ajax-cart-trigger] [data-ajax-cart-mini_cart]').css('display', 'block');
      }

      this.$el.find('.sticky-menu-wrapper').removeClass('is-visible');
      this.$menuToggle.removeClass('is-active');

      if (this.enable_overlay === true && this.sectionUnderlayIsImage() === true) {
        this.updateOverlayStyle(this.sectionUnderlayIsImage());
      }
    })
  },
  disableOverlayStyle: function() {
    //console.log("disable overlay")
    $('[data-enable_overlay]').attr('data-enable_overlay', false);
  },
  enableOverlayStyle: function() {
    //console.log("enable overlay")
    $('[data-enable_overlay]').attr('data-enable_overlay', true);
  },
  updateOverlayStyle: function(overlayBoolean) {
    $('[data-enable_overlay]').attr('data-enable_overlay', overlayBoolean);
  },
  sectionUnderlayIsImage: function() {

    let $firstSection = $('[data-check-for-order=true]').find('[id^=shopify-section]').first();

    // Check whether the first element has class to indicate it should be under header when overlay is enabled
    if ($firstSection.hasClass('overlaid-header-option') && $.trim($firstSection.html()).length > 0) {
      return true;
    } else {
      return false;
    }

  },
  showDrawer: function () {
    // console.log("showDrawer")  
    //debugger
    
    if (this.cart_action != 'drawer') return false;
    // console.log("after drawer if statement")
    $('[data-ajax-cart-drawer]').addClass('is-visible');
    /*tweaking the class amp-cart */
    $('[amp-cart]').removeClass('false');
    $('[amp-cart]').addClass('amp-cart--open');
    // console.log("after adding class")
    $('.ajax-cart__overlay').addClass('is-visible');
    // console.log("after ajax-cart__overlay class manipulation")
  },
  hideDrawer: function () {
    // console.log("hide the drawer")
    if (this.cart_action != 'drawer') return false;
    // console.log("after if statement")
    $('[data-ajax-cart-redirect_cart]').removeClass('is-visible');
    $('.ajax-cart__overlay').removeClass('is-visible');
  },
  removeFromCart: function (lineID, callback) {
    // console.log("removeFromCart")
    $.ajax({
      type: 'POST',
      url: '/cart/change.js',
      data: 'quantity=0&line=' + lineID,
      dataType: 'json',
      success: function (cart) {
        window.PXUTheme.jsAjaxCart.updateView();
      },
      error: function (XMLHttpRequest, textStatus) {
        var response = eval('(' + XMLHttpRequest.responseText + ')');
        response = response.description;

      }
    });
  },
  showSearch: function() {
    // console.log("ShowSearch")
    $('[data-show-search-trigger]').addClass('is-active');
    if(window.PXUTheme.theme_settings.search_layout == 'overlay') {
      //console.log("ello there")
      $('[data-search-type="overlay"]').addClass('is-opened');
      $('.search-form .search__fields input[type="text"]').focus();
      window.PXUTheme.predictiveSearch.lockBodyScroll();
    } else {
      //console.log("hello there")
      $.fancybox.open($('.js-search-popup'), {
        baseClass: 'search__lightbox',
        hash: false,
        infobar : false,
        toolbar: false,
        loop: true,
        smallBtn : true,
        mobile: {
          preventCaptionOverlap: false,
          toolbar: false,
        },
        afterShow: function() {
          // console.log("aftershow")
          // Set the cursor at the end of the input field for better UX,
          // otherwise it may be at the beginning of the input field when the input gets focus.
          const searchInputEl = $('.search-form .search__fields input[type="text"]')[0];
          const searchTermLength = searchInputEl.value.length;
          searchInputEl.setSelectionRange(searchTermLength, searchTermLength);
          $('.js-search-popup').attr('aria-hidden', false);
        },
        beforeClose: function(){
          // console.log("beforeshow")
          $('[data-show-search-trigger]').removeClass('is-active');
          $('.js-search-popup').attr('aria-hidden', true);
        },
      })
    }
  },
    showMobileSearch: function() {
    // console.log("ShowMobileSearch")
    $('[search-overlay-mobile]').attr('aria-expanded', true);
    $('[search-overlay-mobile]').attr('aria-controls', 'snize-instant-search-results');
  },
  hideSearch: function() {
    $('[data-show-search-trigger]').removeClass('is-active');
    if(window.PXUTheme.theme_settings.search_layout == 'overlay' || window.PXUTheme.theme_settings.header_layout == 'search_focus' || window.PXUTheme.theme_settings.header_layout == 'vertical') {
      $('[data-autocomplete-true] .search__results-wrapper').hide();
      $('[data-search-type="overlay"]').removeClass('is-opened');
      window.PXUTheme.predictiveSearch.unlockBodyScroll();
    } else {
      $.fancybox.close($('[data-search-type="'+window.PXUTheme.theme_settings.search_layout+'"]'));
    }
  },
  addOffScreenDropdownCheck: function() {
    $('.navbar-item.has-dropdown--vertical').hover(function() {

      const dropdown = $(this),
      menu = dropdown.find('.navbar-dropdown');

      menu.removeClass('navbar-dropdown--fix-offscreen');

      if (menu.is(':off-screen')) {
        menu.addClass('navbar-dropdown--fix-offscreen');
      }

      });
  },
  getHeaderHeight: function() {
    const headerHeight = $('.header-section').outerHeight() || 0;

    return headerHeight;
  },
  unload: function($section) {
    $('.has-overlaid-header').removeClass('has-overlaid-header');
    $('[data-show-search-trigger]').off();
    $('.navbar-item').off();
    $('#header').off();
    $('.dropdown-click--true .header__link').off();
    this.$menuToggle.off();
    this.disableSticky();
    this.disableOverlayStyle();
  }
}

/******/ })()
;